import { Button, Input, Label } from "reactstrap";
import { Link } from "react-router-dom";
import React from "react";

const LoginToManageYourEvent = ({
  setEventUserLoggedIn,
  eventUserLoggedIn,
}) => {
  return (
    <div>
      <div className={" text-center"}>
        <h4 className="create-company-title mt-2 ">Login to your Event</h4>
      </div>
      <div>
        <div className="p-2 mt-4">
          <div className="mb-3">
            <Label htmlFor="email" className="form-label">
              Email / Phone Number
            </Label>
            <Input
              name="email"
              className="form-control"
              placeholder="Enter email"
              type="email"
            />
          </div>

          <div className="mb-3">
            <Label className="form-label" htmlFor="password-input">
              Event Token
            </Label>
            <div className="position-relative auth-pass-inputgroup mb-3">
              <Input
                name="password"
                type="password"
                className="form-control pe-5"
                placeholder="Enter Password"
              />

              <button
                className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                type="button"
                id="password-addon"
              >
                <i className="ri-eye-fill align-middle"></i>
              </button>
            </div>
          </div>

          <div className="form-check">
            <div
              className={"d-flex justify-content-between align-items-center"}
            >
              <div className={"text-end w-100"}>
                <Link to="#" className="text-muted">
                  Forgot Token?
                </Link>
              </div>
            </div>
          </div>

          <div className="mt-4">
            <Button
              onClick={() => setEventUserLoggedIn(!eventUserLoggedIn)}
              color="success"
              className="btn btn-success w-100"
            >
              Sign In
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginToManageYourEvent;
